import { useMemo as e, createElement as t } from "react";
import { RUMContext as o } from "./RUMContext.js";
import { rum as r } from "@quintoandar/rum";
var n = function n() {},
  d = {
    start: n,
    stop: n,
    eventIdleTime: n
  },
  i = function i(_ref) {
    var n = _ref.callback,
      i = _ref.children;
    var m = "undefined" != typeof window && "undefined" != typeof document,
      a = e(function () {
        return m ? r(n) : d;
      }, [m]);
    return /*#__PURE__*/t(o.Provider, {
      value: a
    }, i);
  };
export { i as RUMProvider };